import * as React from "react";
import ImageUploading from "react-images-uploading";
import {useState} from "react";
import {Stack, Typography} from "@mui/material";
import {ReactComponent as UploadImage} from "../../icon/UploadImage.svg";
import {validateImage} from "./ImageValidator";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {truncateStr} from "../Service";


const FileUploader = ({setImageToUpload, setLabelImage, labelImage, onError, setImageError}) => {
    const [image, setImage] = useState([]);
    const {mode} = useDarkMode();
    const onChange = (image) => {
        console.log(image);
        const validationResponse = validateImage(image[0].file);
        if (validationResponse) {
            setImage(image);
            setImageToUpload(image);
            setLabelImage(image[0].file.name);
            setImageError(false)
        } else {
            setLabelImage('Format d\'image invalide');
        }

    };

    return (
        <ImageUploading
            value={image}
            onChange={onChange}
            dataURLKey="data_url"
            name={'eventImage'}
        >
            {({
                  onImageUpload,
              }) => (
                  <Stack gap={'4px'}>
                      <Stack
                          direction="row"
                          justifyContent="left"
                          alignItems="center"
                          spacing={2}
                          onClick={onImageUpload}
                          sx={{cursor:'pointer'}}
                      >
                          <UploadImage></UploadImage>
                          <Typography variant={'body2'} color={mode.settings.textColor3}>{truncateStr(labelImage, 20)}</Typography>
                      </Stack>
                      {
                          onError &&
                          <Typography variant={'subtitle4'} color={'#d32f2f'}>Ce champ est obligatoire.</Typography>
                      }
                  </Stack>

            )}
        </ImageUploading>
    )
}

export default FileUploader;
